import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = {
    key: 0,
    class: "quantity__portioning"
};
const _hoisted_3 = { class: "quantity__portioning-input" };
const _hoisted_4 = { class: "quantity__portioning-label" };
const _hoisted_5 = { class: "quantity__portioning-label" };
const _hoisted_6 = { class: "quantity__portioning-total" };
const _hoisted_7 = { class: "quantity__portioning-label quantity__portioning-label--total" };
const _hoisted_8 = { class: "quantity__portioning-label quantity__portioning-label--quantity" };
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import events from "@astina/paloma-common-ui/src/services/EventBus";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
import NumberInput from "@astina/paloma-common-ui/src/components/NumberInput.vue";
import OrderUtils from "../services/OrderUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticleQuantityInput',
    props: {
        config: {},
        available: { type: Boolean },
        resetOnCartItemAdded: { type: Boolean },
        resetPortionsOnClose: { type: Boolean },
        quantityIsReserved: { type: Boolean },
        displayPortions: {},
        tabIndex: {},
        sku: {},
        unitCode: {},
        quantityChangeDebounce: {},
        applyInventoryUpdates: { type: Boolean }
    },
    emits: [
        'change',
        'validityChange',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        let quantityChangeTimeout = null;
        const props = __props;
        const emit = __emit;
        const maxClamped = computed(() => {
            // clamp to 9999 because the input is not wide enough to allow more
            //   than 4 digits!
            if (typeof props.config.max !== 'number') {
                return 9999;
            }
            let max;
            if (props.quantityIsReserved) {
                max = props.config.max + quantity.value.quantity;
            }
            else {
                max = props.config.max;
            }
            if (max > 9999) {
                return 9999;
            }
            return max;
        });
        const disabled = computed(() => {
            return !props.available
                || !isGranted('PORTAL_ORDERS_CREATE', 'ORDERS_CREATE', 'PORTAL_DEMAND_MANAGE')
                || maxClamped.value <= 0;
        });
        const quantity = ref({ quantity: 0 });
        const quantityPerPortion = ref(null);
        const minQuantityPerPortion = ref(null);
        const maxQuantityPerPortion = ref(null);
        const isPortionable = ref(false);
        const showPortioningInput = ref(false);
        const portionsInvalid = ref(false);
        const quantityPerPortionInvalid = ref(false);
        onMounted(() => {
            init();
            if (props.resetOnCartItemAdded) {
                events.$on('command.add_cart_items.success', resetQuantity);
            }
            if (props.sku) {
                events.$on(`shop.inventory-update.${props.sku}`, onInventoryUpdate);
            }
        });
        watch(() => props.available, init);
        function init() {
            resetQuantity();
        }
        onUnmounted(() => {
            events.$off('command.add_cart_items.success', resetQuantity);
            if (props.sku) {
                events.$off(`shop.inventory-update.${props.sku}`, onInventoryUpdate);
            }
        });
        function onQuantityChange(_quantity) {
            let quantityLocal = _quantity;
            if (quantityPerPortion.value) {
                quantity.value.portions = calculatePortionsForQuantity(_quantity);
                quantityLocal = calculateQuantityForPortions();
            }
            else if (quantity.value.portions) {
                quantityPerPortion.value = calculateQuantityPerPortion(quantityLocal);
            }
            if (props.quantityChangeDebounce) {
                quantityChangeTimeout && window.clearTimeout(quantityChangeTimeout);
                quantityChangeTimeout = window.setTimeout(() => {
                    updateQuantity(quantityLocal);
                    quantityChangeTimeout = null;
                }, props.quantityChangeDebounce);
            }
            else {
                updateQuantity(quantityLocal);
            }
        }
        function onValidityChange(validity) {
            emit('validityChange', validity);
        }
        function onValidityChangePortions(validity) {
            if (bothPortionInfosValidOrInvalid()) {
                return;
            }
            portionsInvalid.value = !validity;
            if (bothPortionInfosValidOrInvalid()) {
                emit('validityChange', validity);
            }
        }
        function onValidityChangeQuantityPerPortion(validity) {
            if (bothPortionInfosValidOrInvalid()) {
                return;
            }
            quantityPerPortionInvalid.value = !validity;
            if (bothPortionInfosValidOrInvalid()) {
                emit('validityChange', validity);
            }
        }
        function bothPortionInfosValidOrInvalid() {
            return (portionsInvalid.value && quantityPerPortionInvalid.value)
                || (!portionsInvalid.value && !quantityPerPortionInvalid.value);
        }
        function onPortionsChange(_portions) {
            quantity.value.portions = _portions > 0 ? _portions : undefined;
            if (quantity.value.portions) {
                if (quantityPerPortion.value === null) {
                    quantityPerPortion.value = calculateQuantityPerPortion();
                    emitChange();
                }
                else {
                    const quantityLocal = calculateQuantityForPortions();
                    if (quantity.value.quantity !== quantityLocal) {
                        updateQuantity(quantityLocal);
                    }
                }
            }
        }
        function onQuantityPerPortionChange(quantityPerPortionParam) {
            quantityPerPortion.value = quantityPerPortionParam || null;
            if (quantityPerPortion.value !== null) {
                if (quantity.value.portions === undefined) {
                    quantity.value.portions = calculatePortionsForQuantity();
                    emitChange();
                }
                else {
                    const quantityLocal = calculateQuantityForPortions();
                    if (quantity.value.quantity !== quantityLocal) {
                        updateQuantity(quantityLocal);
                    }
                }
            }
        }
        function calculateQuantityForPortions() {
            const quantityLocal = quantityPerPortion.value * quantity.value.portions
                / (props.config.portioningNumerator || 1)
                * (props.config.portioningDenominator || 1);
            return parseFloat(quantityLocal.toFixed(props.config.decimals));
        }
        function calculateQuantityPerPortion(quantityParam) {
            return OrderUtils.calculateQuantityPerPortion(quantity.value, props.config, quantityParam);
        }
        function calculatePortionsForQuantity(forQuantity) {
            return Math.round((forQuantity || quantity.value.quantity)
                / quantityPerPortion.value
                * (props.config.portioningNumerator || 1)
                / (props.config.portioningDenominator || 1));
        }
        function togglePortioning() {
            if (showPortioningInput.value) {
                showPortioningInput.value = false;
                if (props.resetPortionsOnClose) {
                    quantity.value.portions = undefined;
                    quantityPerPortion.value = null;
                }
            }
            else {
                showPortioningInput.value = true;
            }
        }
        function updateQuantity(newQuantity) {
            if (quantity.value.quantity !== newQuantity) {
                quantity.value.quantity = newQuantity;
                emitChange();
            }
        }
        function emitChange() {
            emit('change', quantity.value);
        }
        watch(() => props.config, resetQuantity);
        watch(() => props.config.initial, resetQuantity);
        watch(() => props.config.portioning, resetQuantity);
        watch(() => props.config.portions, resetQuantity);
        function resetQuantity() {
            quantity.value.quantity = props.config.initial;
            quantity.value.portions = props.config.portions;
            quantityPerPortion.value = (props.config.portioning
                && props.config.portioning !== 'none'
                && quantity.value.portions
                && quantity.value.quantity)
                ? calculateQuantityPerPortion()
                : null;
            isPortionable.value = props.config.portioning ? props.config.portioning !== 'none' : false;
            // calculate min/max portion quantity
            if (isPortionable.value) {
                if (props.config.min !== undefined) {
                    minQuantityPerPortion.value = props.config.min
                        * (props.config.portioningNumerator || 1)
                        / (props.config.portioningDenominator || 1);
                }
                if (props.config.max !== undefined) {
                    maxQuantityPerPortion.value = props.config.max
                        * (props.config.portioningNumerator || 1)
                        / (props.config.portioningDenominator || 1)
                        / quantity.value.quantity;
                }
            }
            showPortioningInput.value = isPortionable.value
                && (props.config.portions !== undefined || props.config.portioning === 'required')
                && props.resetPortionsOnClose;
        }
        function onInventoryUpdate(update) {
            props.config.max = Math.max(0, update.availableQuantity);
            if (props.applyInventoryUpdates) {
                if (update.availableQuantity < quantity.value.quantity) {
                    updateQuantity(update.availableQuantity);
                }
                else if (update.availableQuantity <= 0) {
                    updateQuantity(0);
                }
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["quantity", {
                        'quantity--portionable': isPortionable.value,
                        'quantity--portions-left': __props.displayPortions === 'left',
                        'quantity--portions-top': __props.displayPortions === 'top',
                        'quantity--portioning-required': __props.config.portioning === 'required'
                    }])
            }, [
                (isPortionable.value && !disabled.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (togglePortioning()), ["prevent"])),
                            class: "quantity__toggle-portioning",
                            title: _ctx.$t('product.show_portioning_input'),
                            href: ""
                        }, [
                            _createVNode(Icon, {
                                name: "knife-kitchen",
                                "icon-style": quantity.value.portions ? 'solid' : 'regular'
                            }, null, 8, ["icon-style"])
                        ], 8, _hoisted_1),
                        _cache[14] || (_cache[14] = _createTextVNode()),
                        (showPortioningInput.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (togglePortioning()), ["prevent"])),
                                    class: "quantity__close-portioning",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "close" })
                                ]),
                                _cache[12] || (_cache[12] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(NumberInput, {
                                        class: "cart-input-field",
                                        value: quantity.value.portions,
                                        min: 1,
                                        required: __props.config.portioning === 'required',
                                        disabled: disabled.value,
                                        "tab-index": __props.tabIndex,
                                        onChange: onPortionsChange,
                                        onValidityChange: onValidityChangePortions,
                                        onFocus: _cache[2] || (_cache[2] = ($event) => (emit('focus'))),
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (emit('blur')))
                                    }, null, 8, ["value", "required", "disabled", "tab-index"]),
                                    _cache[8] || (_cache[8] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('product.portions_of')), 1),
                                    _cache[9] || (_cache[9] = _createTextVNode()),
                                    _createVNode(NumberInput, {
                                        class: "cart-input-field cart-input-field--quantity-per-portion",
                                        value: quantityPerPortion.value ?? undefined,
                                        min: minQuantityPerPortion.value ?? undefined,
                                        max: maxQuantityPerPortion.value ?? undefined,
                                        decimals: __props.config.decimals,
                                        disabled: disabled.value,
                                        "tab-index": __props.tabIndex,
                                        onChange: onQuantityPerPortionChange,
                                        onValidityChange: onValidityChangeQuantityPerPortion,
                                        onFocus: _cache[4] || (_cache[4] = ($event) => (emit('focus'))),
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (emit('blur')))
                                    }, null, 8, ["value", "min", "max", "decimals", "disabled", "tab-index"]),
                                    _cache[10] || (_cache[10] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.config.portioningUnit || __props.config.unit), 1)
                                ]),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('product.portioning_total')), 1),
                                    _cache[11] || (_cache[11] = _createTextVNode()),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(quantity.value.quantity), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ], 64))
                    : _createCommentVNode("", true),
                _cache[15] || (_cache[15] = _createTextVNode()),
                (!isPortionable.value || !showPortioningInput.value)
                    ? (_openBlock(), _createBlock(NumberInput, {
                        key: 1,
                        class: "cart-input-field cart-input-field--quantity",
                        "clamping-mode": "onbutton",
                        value: quantity.value.quantity,
                        min: __props.config.min,
                        max: maxClamped.value,
                        increment: __props.config.increment,
                        decimals: __props.config.decimals,
                        disabled: disabled.value || __props.config.portioning === 'required',
                        "tab-index": __props.tabIndex,
                        onChange: onQuantityChange,
                        onValidityChange: onValidityChange,
                        onFocus: _cache[6] || (_cache[6] = ($event) => (emit('focus'))),
                        onBlur: _cache[7] || (_cache[7] = ($event) => (emit('blur')))
                    }, null, 8, ["value", "min", "max", "increment", "decimals", "disabled", "tab-index"]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
